import { type LineItemsState } from "@reducers/line-items";
import { createContext, useContext } from "react";

export interface SubscriptionFlowData {
  city?: string;
  country?: string;
  email?: string;
  phone_number?: string;
  promocode: string;
  zipcode: string;
  numberOfLines: number;
  lines: LineItemsState;
  terms: boolean;
  selectedPlan: Plan;
  showHint: boolean;
  paymentData: PaymentData;
  verified: boolean;
  checkout: {
    order_number: string;
  };
}

interface PaymentData {
  discount: number;
  message?: string;
  sub_total: number;
  tax: number;
  total: number;
}

interface SubscriptionDataContextType {
  plans: Plan[];
  setPlans: (plans: Plan[]) => void;
  data: SubscriptionFlowData;
  addData: (data: Partial<SubscriptionFlowData>) => void;
  setGoBack: (fn: () => void) => void;
  navigation: {
    goBack: () => void;
  };
}

export const SUBS_INIT_DATA: SubscriptionFlowData = {
  email: "",
  promocode: "",
  zipcode: "",
  numberOfLines: 0,
  lines: [] as unknown as Lines,
  terms: false,
  selectedPlan: null as unknown as Plan,
  showHint: true,
  checkout: null as any,
  paymentData: null as unknown as PaymentData,
  verified: false,
};

const SubscriptionDataContext = createContext<SubscriptionDataContextType>({
  data: SUBS_INIT_DATA,
  setPlans: () => {},
  addData: () => {},
  setGoBack: () => {},
  navigation: {
    goBack: () => null,
  },
  plans: null as unknown as Plan[],
});

export default SubscriptionDataContext;

export const useSubscriptionContext = (): SubscriptionDataContextType => {
  const context = useContext(SubscriptionDataContext);
  if (!context) {
    throw new Error(
      "useSubscriptionContext must be used within a SubscriptionDataProvider",
    );
  }
  return context;
};
